const colors = {
    // -- primary colors -- //
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use plum-700 moving forward */
    plum: '#650360',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gray-200 moving forward */
    'page-gray': '#F2F2F2',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gray-300 moving forward */
    'slate-1': '#E5E5E5',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gray-800 moving forward */
    'slate-5': '#2A2A2A',
    // -- secondary colors -- //
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use blue-200 moving forward */
    'patina-1': '#E7F6FD',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please update designs or hardcode this value moving forward */
    'patina-2': '#D7E4EB',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please update designs or hardcode this value moving forward */
    'patina-3': '#C0D0D8',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use blue-600 moving forward */
    'sky-2': '#3798C7',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gold-200 moving forward */
    sand: '#E8D4A3',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gray-100 moving forward */
    'light-gray': '#F8F8F8',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gray-300 moving forward */
    'slate-2': '#DDDDDD',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gray-500 moving forward */
    'slate-3': '#959595',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gray-600 moving forward */
    'slate-4': '#666666',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gray-400 moving forward */
    'slate-8': '#BBBBBB',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gray-400 moving forward */
    'grey-80': '#CCCCCC',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please update designs or hardcode this value moving forward */
    'yacht-rock': '#E3ECF1',
    // -- anomaly marketing colors -- //
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use blueberry-700 moving forward */
    blueberry: '#371447',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use champagne-100 moving forward */
    champagne: '#FAF3EC',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use grapefruit-600 moving forward */
    grapefruit: '#CE477E',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use plum-600 moving forward */
    grape: '#8A3575',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use seafoam-700 moving forward */
    seafoam: '#1C988A',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use blue-800 moving forward */
    bluesuedeshoes: '#0071C4',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use blue-800 with an opacity moving forward */
    skyblue: '#0071C480',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use slate-700 moving forward */
    midnightblue: '#2A2D40',
    // -- tertiary colors -- //
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use teal-600 moving forward */
    toaster: '#008486',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use red-600 moving forward */
    error: '#D63440',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use green-600 moving forward */
    success: '#0B8100',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please update designs or hardcode this value moving forward */
    'field-focus': '#FFFFE7',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use blue-800 moving forward */
    'sky-4': '#0079B3',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use blue-800 moving forward */
    'sky-3': '#006899',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use blue-400 moving forward */
    'sky-1': '#8BD3F5',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gold-600 moving forward */
    warning: '#EB6600',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gray-200 moving forward */
    'periwinkle-100': '#F0F2F5',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use slate-300 moving forward */
    'periwinkle-300': '#C0C8D6',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use slate-400 moving forward */
    'periwinkle-500': '#8391AF',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use grapefruit-600 moving forward */
    'ally-grapefruit': '#CB3974',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use blue-800 moving forward */
    'link-blue': '#0071C4',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use blue-900 moving forward */
    'hover-blue': '#0065B0',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use red-600 moving forward */
    'error-red': '#D63440',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use red-700 moving forward */
    'hover-red': '#C02E39',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use green-600 moving forward */
    'success-green': '#1B8355',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use green-700 moving forward */
    'hover-green': '#18754C',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gold-600 moving forward */
    'alert-orange': '#EB6600',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gold-300 moving forward */
    'ratings-yellow': '#FFDC7A',
    /** @deprecated - will be removed in version 31.0.0 on 07/01/2025 - please use gold-100 moving forward */
    'highlight-yellow': '#FFEAC8',
    // -- account colors -- //
    ira: '#FF5722',
    cda: '#9C27B0',
    dda: '#03A9F4',
    cc: '#FFC107',
    sda: '#3F51B5',
    cmg: '#3F51B5',
    mma: '#3F51B5',
    inv: '#009688',
    inva: '#65C6BB',
    invw: '#6E8FAA',
    auto: '#5E7B87',
    dealer: '#424E61',
    external: '#666666',
    mortgage: '#8BC34A',
    // -- accessible account colors -- //
    'a11y-cmg': '#5A822B',
    'a11y-inv': '#008577',
    'a11y-dda': '#027DB6',
    'a11y-auto': '#5E7B87',
    'a11y-dealer': '#424E61',
    // -- fresh colors -- //
    white: '#FFFFFF',
    black: '#000000',
    // transparent
    transparent: 'rgba(0,0,0,0)',
    // gray
    'gray-100': '#F9F9F9',
    'gray-200': '#F2F2F2',
    'gray-300': '#DDDDDD',
    'gray-400': '#BBBBBB',
    'gray-500': '#909090',
    'gray-600': '#737373',
    'gray-700': '#444444',
    'gray-800': '#2A2A2A',
    'gray-900': '#1A1A1A',
    // slate
    'slate-100': '#E7EAF7',
    'slate-200': '#D3D8E6',
    'slate-300': '#C0C8D6',
    'slate-400': '#8391AF',
    'slate-500': '#667799',
    'slate-600': '#363844',
    'slate-700': '#2B2D36',
    'slate-800': '#252730',
    'slate-900': '#16181E',
    // blue
    'blue-100': '#F1FAFF',
    'blue-200': '#E3F5FF',
    'blue-300': '#B7E4F8',
    'blue-400': '#8BD3F5',
    'blue-500': '#55BDF1',
    'blue-600': '#4CA9D8',
    'blue-700': '#2A97DA',
    'blue-800': '#0071C4',
    'blue-900': '#0065B0',
    // green
    'green-100': '#D1F4DD',
    'green-200': '#A3E9BB',
    'green-300': '#48D37D',
    'green-400': '#40BD70',
    'green-500': '#2DA062',
    'green-600': '#1B8355',
    'green-700': '#18754C',
    'green-800': '#125839',
    'green-900': '#0C3B26',
    // red
    'red-100': '#FED3D3',
    'red-200': '#FCA7A7',
    'red-300': '#FC7C7C',
    'red-400': '#FA5050',
    'red-500': '#E04747',
    'red-600': '#D63440',
    'red-700': '#C02E39',
    'red-800': '#90232B',
    'red-900': '#60171D',
    // gold
    'gold-100': '#FFEAC8',
    'gold-200': '#FFE2A0',
    'gold-300': '#FFDC7A',
    'gold-400': '#FEB13C',
    'gold-500': '#FE8700',
    'gold-600': '#EB6600',
    'gold-700': '#AB5410',
    'gold-800': '#974F15',
    'gold-900': '#433929',
    // teal
    'teal-100': '#CDEEE5',
    'teal-200': '#9BDECC',
    'teal-300': '#69CDB5',
    'teal-400': '#37BEA0',
    'teal-500': '#009688',
    'teal-600': '#00857F',
    'teal-700': '#00756B',
    'teal-800': '#00685F',
    'teal-900': '#00433D',
    // purple
    'purple-100': '#DEC8FF',
    'purple-200': '#C59EFA',
    'purple-300': '#AD75F5',
    'purple-400': '#7E78F4',
    'purple-500': '#655BCA',
    'purple-600': '#594DB5',
    'purple-700': '#4D40A1',
    'purple-800': '#372765',
    'purple-900': '#210F29',
    /** BRAND COLORS **/
    // plum
    'plum-100': '#FEE6FF',
    'plum-200': '#F6CBF7',
    'plum-300': '#DF9DDE',
    'plum-400': '#BC79BE',
    'plum-500': '#954293',
    'plum-600': '#7D2279',
    'plum-700': '#650360',
    'plum-800': '#4B0247',
    'plum-900': '#2E1B2E',
    // blueberry
    'blueberry-100': '#E9CFFF',
    'blueberry-200': '#CCA1E5',
    'blueberry-300': '#BB72DD',
    'blueberry-400': '#8D4CAB',
    'blueberry-500': '#5F2779',
    'blueberry-600': '#4B1D60',
    'blueberry-700': '#300942',
    'blueberry-800': '#290E35',
    'blueberry-900': '#1B0923',
    // grapefruit
    'grapefruit-100': '#FFDBE8',
    'grapefruit-200': '#FFB7D1',
    'grapefruit-300': '#FF92BA',
    'grapefruit-400': '#FE679E',
    'grapefruit-500': '#FE4A8B',
    'grapefruit-600': '#DC2075',
    'grapefruit-700': '#B42C63',
    'grapefruit-800': '#802750',
    'grapefruit-900': '#651C39',
    // seafoam
    'seafoam-100': '#E3FFFA',
    'seafoam-200': '#9EEFE1',
    'seafoam-300': '#5DE2CC',
    'seafoam-400': '#22D6B7',
    'seafoam-500': '#33C1A6',
    'seafoam-600': '#27AC97',
    'seafoam-700': '#1C988A',
    'seafoam-800': '#147167',
    'seafoam-900': '#0D4B44',
    // champagne
    'champagne-100': '#FFF7F0',
};
export default colors;
//# sourceMappingURL=colors.js.map